import { apiClient } from 'utils/apiClient';
import { ApiEndpoints } from 'models/apiEndpoints';
import { isResponseError } from 'models/apiClient';
import { IGlobalProperty } from 'models/globalProperty';

const getGlobalProperties = async (): Promise<IGlobalProperty[] | null> => {
  const { data } = await apiClient.get(ApiEndpoints.GET_GLOBAL_PROPERTIES());

  if (isResponseError(data)) {
    return null;
  }

  return data;
};

const getGlobalPropertyByKey = async (key: string): Promise<IGlobalProperty | null> => {
  const { data } = await apiClient.get(ApiEndpoints.GET_GLOBAL_PROPERTY_BY_KEY(key));

  if (isResponseError(data)) {
    return null;
  }

  return data;
};

const getLicenceRenewThreshold = async (): Promise<number | null> => {
  const property = await getGlobalPropertyByKey('licence_renew_minimum_days_threshold');

  if (!property || !property.value) {
    return null;
  }

  const days = parseInt(property.value, 10);
  return Number.isNaN(days) ? null : days;
};

const updateLicenceRenewBeforeExpiration = async (days: number): Promise<boolean> => {
  const { data } = await apiClient.put(
    `${ApiEndpoints.UPDATE_LICENCE_RENEWAL_ALLOWED_DAYS_BEFORE_EXPIRATION()}?value=${days}`,
  );

  return !isResponseError(data);
};

const updateLicenceExpirationNotificationDaysBefore = async (
  days: number,
): Promise<boolean> => {
  const { data } = await apiClient.put(
    `${ApiEndpoints.UPDATE_LICENCE_EXPIRATION_NOTIFICATION_DAYS_BEFORE()}?value=${days}`,
  );

  return !isResponseError(data);
};

export {
  getGlobalProperties,
  getGlobalPropertyByKey,
  getLicenceRenewThreshold,
  updateLicenceRenewBeforeExpiration,
  updateLicenceExpirationNotificationDaysBefore,
};
